export const REACT_APP_BASE_URL = "https://webservices.gabapentinshop.com/wp-content/themes/gabapentinshop/API"
export const REACT_APP_MAIL_URL = "https://gabapentinshop.com/api"
// export const REACT_APP_MAIL_URL = "http://localhost:5000/api"